var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM6.5 7.5C6.5 7.04037 6.59053 6.58525 6.76642 6.16061C6.94231 5.73597 7.20012 5.35013 7.52513 5.02513C7.85013 4.70012 8.23597 4.44231 8.66061 4.26642C9.08525 4.09053 9.54037 4 10 4C10.4596 4 10.9148 4.09053 11.3394 4.26642C11.764 4.44231 12.1499 4.70012 12.4749 5.02513C12.7999 5.35013 13.0577 5.73597 13.2336 6.16061C13.4095 6.58525 13.5 7.04037 13.5 7.5C13.5 8.42826 13.1313 9.3185 12.4749 9.97487C11.8185 10.6313 10.9283 11 10 11C9.07174 11 8.1815 10.6313 7.52513 9.97487C6.86875 9.3185 6.5 8.42826 6.5 7.5ZM16.258 14.984C15.5092 15.9253 14.5575 16.6855 13.4739 17.2077C12.3904 17.7299 11.2029 18.0008 10 18C8.79715 18.0008 7.60965 17.7299 6.52607 17.2077C5.44249 16.6855 4.49081 15.9253 3.742 14.984C5.363 13.821 7.575 13 10 13C12.425 13 14.637 13.821 16.258 14.984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersidebar);
export default __webpack_public_path__ + "static/media/usersidebar.c764fcdb216989285b50e149a11ebf38.svg";
export { ForwardRef as ReactComponent };